import ChatIcon from '@mui/icons-material/Chat';
import { SvgIconProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ChatNotificationIcon({ htmlColor, ...props }: SvgIconProps) {
  const theme = useTheme();
  return <ChatIcon htmlColor={htmlColor || theme.palette.secondary.main} {...props} />;
}
